var tooltip = {
    init: function() {
        $('[data-tooltip]').each(function() {
            tooltip.qtip($(this));
        });
    },
    modal: function() {
        if ($('.modal-body [data-tooltip]').length > 0) {
            $('.modal-body [data-tooltip]').each(function() {
                tooltip.qtip($(this));
            });
        }
    },
    qtip: function(handler) {
        const that = handler;
        const style = that.data('style') || 'qtip-default';
        const onClick = that.data('on-click') || false;
        const html = that.data('html') || false;
        const my = !window._d.isRTL ? that.data('my') || 'bottom center' : 'bottom center';
        const at = that.data('at') || 'top center';
        const adjustX = that.data('adjust-x') || 0;
        const adjustY = that.data('adjust-y') || 0;
        const stayVisible = that.data('stay-visible') || false;

        let options = {
            position: {
                my: my,
                at: at,
                adjust: {
                    x: adjustX,
                    y: adjustY
                }
            },
            style: {
                classes: style
            },
            content: {
                text: (html ? that.find('.' + html) : '<span class="qtip-arrow"></span>' + that.attr('data-tooltip'))
            }
        };

        if (onClick) {
            options.show = 'click';
            options.hide = 'unfocus';
        }

        if (stayVisible) {
            options.hide = {
                fixed: true,
                delay: 100
            };
        }

        that.qtip(options);
    },
    hide: function() {
        $('[data-tooltip]').qtip('hide');
    }
};
